<div id="slickcarousel-{{cid}}" class="slickcarousel">
  {{#each slides}}
    {{#if blocks}}
    <div data-region="{{../cid}}-slides-{{@index}}-blocks"></div>
    {{/if}}
  {{/each}}
</div>
